import React from 'react';
import PropTypes from 'prop-types';

import ResearchReport from '../ResearchReport/index.jsx';


class ResearchReportsList extends React.Component {
  handleArticleUpdate(article, type, data) {
    if (this.props.onArticleUpdate) {
      this.props.onArticleUpdate(article, type, data);
    }
  }

  render() {
    var result = null;

    var innerContent = [];
    for (var i = 0; i < this.props.articles.length; i++) {
      var article = this.props.articles[i];

      innerContent.push(
        <div key={article.id} className="cs-research-report-articles__item">
          <ResearchReport article={article} />
        </div>
      );
    }

    return (
      <div className="cs-research-report-articles">
        {innerContent}
      </div>
    );
  }
}

ResearchReportsList.propTypes = {
  articles: PropTypes.array,
};

ResearchReportsList.defaultProps = {
  articles: []
};


export default ResearchReportsList;

